import { render, staticRenderFns } from "./RoleAccessPermission.vue?vue&type=template&id=5a86530d&scoped=true"
import script from "./RoleAccessPermission.vue?vue&type=script&lang=js"
export * from "./RoleAccessPermission.vue?vue&type=script&lang=js"
import style0 from "./RoleAccessPermission.vue?vue&type=style&index=0&id=5a86530d&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a86530d",
  null
  
)

export default component.exports